import moment from 'moment';
import {
  CleanRoomTypesCell,
  TypeCell,
} from 'pages/QuestionManagement/CellComponents';
import { QUESTION_STATUS } from 'utils/constants/question.constant';
import {
  TagsCell,
} from 'components/CleanRooms/CurrentQuestions/QuestionsTableLayout/TableCellComponents';
import { US_DATE_FORMAT } from 'utils/appConstants';
import { cellTypesEnum } from 'BaseComponents';


export const columns = [{
  field: 'displayID',
  name: 'Display ID',
  width: 120,
}, {
  field: 'questionName',
  name: 'Question',
  type: cellTypesEnum.LINE_5,
  width: 280,
}, {
  field: 'isUserListQuestion',
  name: 'Type',
  width: 80,
  component: TypeCell,
}, {
  field: 'category',
  name: 'Category',
  width: 100,
}, {
  field: 'tags',
  name: 'Tags',
  type: cellTypesEnum.LINE_5,
  width: 280,
  component: TagsCell,
}, {
  field: 'cleanRoomTypes',
  name: 'Compatible Clean Rooms',
  width: 280,
  component: CleanRoomTypesCell,
}, {
  field: 'numberOfProvisionedAccounts',
  name: 'Accounts',
  width: 100,
}, {
  field: 'numberOfProvisionedOrganizations',
  name: 'Organization',
  width: 100,
}, {
  field: 'createdOn',
  name: 'Date Created',
  width: 140,
  valueGetter: ({ row }) => moment(row.createdOn).format(US_DATE_FORMAT),
}, {
  field: 'status',
  name: 'Status',
  width: 90,
  valueGetter: ({ row }) => QUESTION_STATUS[row.status].value,
}];
